import { useMutation, useQueryClient } from "@tanstack/react-query";
import { trainerAvailabilityApi } from "api/trainers/trainerAvailabilityApi";
import { QUERIES_KEYS } from "queries";

export const useCancelAvailabilityRequest = (trainerId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (requestId: number) => trainerAvailabilityApi.cancelAvailabilityRequest(trainerId, requestId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.TRAINER_AVAILABILITY_REQUESTS(trainerId) });
    },
  });
};
